export function centerCropToBlob(file: File, aspectRatio: number): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      const { naturalWidth: w, naturalHeight: h } = img;
      let cropW: number;
      let cropH: number;
      if (w / h > aspectRatio) {
        cropH = h;
        cropW = h * aspectRatio;
      } else {
        cropW = w;
        cropH = w / aspectRatio;
      }
      const x = (w - cropW) / 2;
      const y = (h - cropH) / 2;
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(cropW);
      canvas.height = Math.round(cropH);
      const ctx = canvas.getContext('2d')!;
      ctx.drawImage(img, x, y, cropW, cropH, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        blob => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('centerCrop: toBlob returned null'));
          }
        },
        'image/webp',
        0.85,
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('centerCrop: image load failed'));
    };
    img.src = url;
  });
}
